import { apiRequest, USE_MOCKS } from './client'
import type {
  SecretListResponse,
  SecretMetadata,
  CreateSecretRequest,
  UpdateSecretRequest,
  RotateTokenRequest,
  RotateTokenResponse,
} from '@/types'
import { mockListSecrets, mockCreateSecret, mockUpdateSecret, mockDeleteSecret } from '@/mocks/secrets'

export async function listSecrets(params?: {
  scope?: string
  scope_key?: string
}): Promise<SecretListResponse> {
  if (USE_MOCKS) return mockListSecrets(params)
  const qs = new URLSearchParams()
  if (params?.scope) qs.set('scope', params.scope)
  if (params?.scope_key) qs.set('scope_key', params.scope_key)
  const query = qs.toString() ? `?${qs}` : ''
  return apiRequest<SecretListResponse>(`/api/secrets${query}`)
}

export async function createSecret(body: CreateSecretRequest): Promise<SecretMetadata> {
  if (USE_MOCKS) return mockCreateSecret(body)
  return apiRequest<SecretMetadata>('/api/secrets', {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export async function updateSecret(
  secretId: string,
  body: UpdateSecretRequest,
): Promise<SecretMetadata> {
  if (USE_MOCKS) return mockUpdateSecret(secretId, body)
  return apiRequest<SecretMetadata>(`/api/secrets/${secretId}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  })
}

export async function deleteSecret(secretId: string): Promise<void> {
  if (USE_MOCKS) return mockDeleteSecret(secretId)
  return apiRequest<void>(`/api/secrets/${secretId}`, { method: 'DELETE' })
}

export async function rotateNodeToken(
  nodeId: string,
  body: RotateTokenRequest,
): Promise<RotateTokenResponse> {
  // backend endpoint: POST /api/nodes/{node_id}/rotate-token
  // mock fallback since backend delivers this in cycle 6
  if (USE_MOCKS) {
    return { token: `mock-token-${Math.random().toString(36).slice(2, 18)}` }
  }
  return apiRequest<RotateTokenResponse>(`/api/nodes/${nodeId}/rotate-token`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}
